import { render, staticRenderFns } from "./active-user.vue?vue&type=template&id=0c791cba&"
import script from "./active-user.vue?vue&type=script&lang=js&"
export * from "./active-user.vue?vue&type=script&lang=js&"
import style0 from "./active-user.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports